import {
  Stack,
  Typography,
  Button,
  Checkbox,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

import { ReactComponent as IconRemedy } from "../../../../images/iconRemedy.svg";
import { ReactComponent as IconTrash } from "../../../../images/iconTrash.svg";
import { ReactComponent as IconEdit } from "../../../../images/iconEdit.svg";

import AccordionSummaryTitle from "../AccordionSummaryTitle";
import {
  FieldSelect,
  FieldAutocomplete,
  FieldInputText,
  FieldTextarea,
} from "../../../../components/Fields";

import "../styles.css";

const MedicineItem = ({
  item,
  index,
  setOpenRemoverMedicamento,
  setRemoverMedicamento,
  handleEditarMedicamento,
}) => {
  return (
    <Stack
      sx={{
        border: "1px solid #1E729F",
        padding: "8px 16px",
        marginBottom: "16px",
        borderRadius: "5px",
        boxShadow: "0px 1px 8px 0px #00000026 !important",
      }}
      key={index}
    >
      <Stack
        direction="row"
        sx={{
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <Stack direction="row" sx={{ alignItems: "center" }}>
          <Checkbox sx={{ color: "#1E729F" }}></Checkbox>
          <Typography className="titleSection" fontSize="16px !important">
            {item.substancia} - {item.nomeMedicamento} - {item.apresentacao}
          </Typography>
        </Stack>

        <Stack direction="row" gap="16px">
          <Button
            style={{ background: "none", border: "none" }}
            onClick={() => {
              setOpenRemoverMedicamento(true);
              setRemoverMedicamento(item);
            }}
          >
            <IconTrash
              style={{
                width: "24px",
                alignSelf: "center",
              }}
            />
          </Button>

          <Button
            style={{ background: "none", border: "none" }}
            onClick={() => {
              handleEditarMedicamento(item);
            }}
          >
            <IconEdit
              style={{
                width: "24px",
                alignSelf: "center",
              }}
            />
          </Button>
        </Stack>
      </Stack>

      <Stack sx={{ pl: "2.5rem" }}>
        <Typography className="subTitleSection" color="#1E729F !important">
          <Typography
            component="span"
            className="titleSection"
            fontSize="16px !important"
          >
            Duração do tratamento:
          </Typography>{" "}
          {item.duracaoTratamento.replace("-", " ")}
        </Typography>
      </Stack>

      <Stack sx={{ pl: "2.5rem" }}>
        <Typography className="subTitleSection" color="#1E729F !important">
          {item.posologia}
        </Typography>
      </Stack>

      <Stack sx={{ pl: "2.5rem" }}>
        <Typography className="subTitleSection" color="#1E729F !important">
          {item.observacao}
        </Typography>
      </Stack>
    </Stack>
  );
};

const handleProgressForm = (data) => {
  if (data.length > 0) {
    return "full";
  } else {
    return "empty";
  }
};

export default function PrescricaoMedicamentos({
  expanded,
  handleChangePanel,
  handleSubmit,
  substanciaList,
  prescricaoMedicamentosState,
  handleSubstancia,
  modoEdicao,
  medicamentosList,
  handleMedicamento,
  apresentacaoList,
  handleApresentacao,
  setPrescricaoMedicamentosState,
  handlePeriodoTratamento,
  periodoTratamentoOptions,
  adicionarMedicamento,
  textoBotaoMedicamento,
  medicamentos,
  editarMedicamento,
  setOpenRemoverMedicamento,
  setRemoverMedicamento,
  handleEditarMedicamento,
}) {
  const progressForm = handleProgressForm(medicamentos);
  return (
    <Accordion
      defaultExpanded={false}
      expanded={expanded === "prescricaoMedicamentos"}
      onChange={handleChangePanel("prescricaoMedicamentos")}
      className="AccordionContainer"
    >
      <AccordionSummary
        expandIcon={<ExpandMore style={{ color: "#1E729F" }} />}
        aria-controls="prescricaoMedicamentos-content"
        id="prescricaoMedicamentos-header"
        className="AccordionSummaryContainer"
      >
        <AccordionSummaryTitle
          title="Prescrição de medicamentos"
          icon={<IconRemedy style={{ width: "24px" }} />}
          progressForm={progressForm}
        />
      </AccordionSummary>
      <AccordionDetails>
        <form autoComplete="off" onSubmit={handleSubmit}>
          <Stack
            className="templateGridForm"
            sx={{
              gridTemplateColumns: "repeat(auto-fit, minmax(330px, 1fr))",
            }}
          >
            <FieldAutocomplete
              label="Substância"
              getOptionLabel={(option) => option.no_substancia || option}
              value={prescricaoMedicamentosState.substancia}
              setValue={(e, value) => handleSubstancia(value)}
              options={substanciaList}
              disabled={modoEdicao}
            />
            <FieldAutocomplete
              label="Nome do medicamento"
              getOptionLabel={(option) => option.no_descricao || option}
              value={prescricaoMedicamentosState.nomeMedicamento}
              setValue={(e, value) => handleMedicamento(value)}
              options={medicamentosList}
              disabled={modoEdicao}
            />
          </Stack>
          <Stack
            className="templateGridForm"
            alignItems="self-start"
            sx={{
              gridTemplateColumns: "repeat(auto-fit, minmax(330px, 1fr))",
            }}
          >
            <FieldAutocomplete
              label="Apresentação"
              getOptionLabel={(option) => option.no_apresentacao || option}
              value={prescricaoMedicamentosState.apresentacao}
              setValue={(e, value) => handleApresentacao(value)}
              options={apresentacaoList}
              disabled={modoEdicao}
            />

            <Stack className="templateGridForm" mb="0px">
              <FieldInputText
                label="Duração do tratamento"
                value={prescricaoMedicamentosState.duracaoTratamento}
                setValue={(value) =>
                  setPrescricaoMedicamentosState((prevState) => ({
                    ...prevState,
                    duracaoTratamento: value,
                  }))
                }
                disabled={
                  prescricaoMedicamentosState.periodoTratamento === "continuo"
                }
              />
              <FieldSelect
                label=""
                value={prescricaoMedicamentosState.periodoTratamento}
                setValue={(value) => handlePeriodoTratamento(value)}
                items={periodoTratamentoOptions.map((c) => {
                  return { id: c.value, label: c.key };
                })}
              />
            </Stack>
          </Stack>

          <FieldTextarea
            label="Posologia"
            value={prescricaoMedicamentosState.posologia ?? ""}
            setValue={(value) =>
              setPrescricaoMedicamentosState((prevState) => ({
                ...prevState,
                posologia: value,
              }))
            }
          />

          <FieldTextarea
            label="Observações"
            value={prescricaoMedicamentosState.observacao ?? ""}
            setValue={(value) =>
              setPrescricaoMedicamentosState((prevState) => ({
                ...prevState,
                observacao: value,
              }))
            }
          />

          <Stack
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              flexDirection: "row",
              marginTop: "16px",
            }}
          >
            <Button
              sx={{
                textTransform: "none",
                fontSize: "1.2rem",
                mb: 5,
                height: "40px",
              }}
              variant="contained"
              type="submit"
              onClick={() => adicionarMedicamento()}
            >
              {textoBotaoMedicamento}
            </Button>
          </Stack>

          {medicamentos.length > 0 && (
            <Stack direction="row" sx={{ alignItems: "center" }} mb="16px">
              <Typography
                component="h2"
                className="titleSection"
                fontSize="20px !important"
              >
                Medicamentos adicionados ({medicamentos.length})
              </Typography>
              <Button
                sx={{
                  color: "darkgray",
                  textTransform: "none",
                  textDecoration: "underline",
                  fontSize: "1.1rem",
                }}
              >
                Gerar receita
              </Button>
            </Stack>
          )}
          {medicamentos.map((medicamento, index) => {
            if (
              medicamento.idMedicamento !== editarMedicamento?.idMedicamento
            ) {
              return (
                <MedicineItem
                  item={medicamento}
                  index={index}
                  setOpenRemoverMedicamento={setOpenRemoverMedicamento}
                  setRemoverMedicamento={setRemoverMedicamento}
                  handleEditarMedicamento={handleEditarMedicamento}
                />
              );
            }
          })}
          <Stack
            direction="row"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mt: 3,
            }}
          >
            <Button variant="outlined" className="buttonText cancel">
              Cancelar
            </Button>
            <Button
              variant="contained"
              type="submit"
              name="prescricaoMedicamentos"
              className="buttonText submit"
            >
              Salvar
            </Button>
          </Stack>
        </form>
      </AccordionDetails>
    </Accordion>
  );
}
